<ng-container *transloco="let t">
  @for (module of modules(); track module.moduleId) {
    @let description = $safeNavigationMigration(module.display?.description);
    @let triggerIcon = $safeNavigationMigration(module.display?.action?.icon) | formIcon;
    @let triggerLabel = $safeNavigationMigration(module.display?.action?.label);

    @if (placement() === 'section') {
      <div class="flex w-full items-center gap-2" [attr.data-testid]="'grid-trigger-section-' + module.moduleId">
        @if (module.isTriggered) {
          <p class="text-text-secondary flex-1 text-sm">
            {{ t('Les champs ont été complétés avec les données associées.') }}
          </p>
        } @else if (description) {
          <p class="text-text-secondary flex-1 text-sm">{{ description }}</p>
        }
        <div class="ml-auto">
          @if (module.isTriggered) {
            <button
              appearance="outline"
              iconStart="@tui.rotate-ccw"
              size="s"
              tuiHintAppearance="floating"
              tuiIconButton
              type="button"
              [tuiHint]="t('Réinitialiser')"
              (click)="resetModule(module)">
              {{ t('Réinitialiser') }}
            </button>
          } @else if (description) {
            <button
              appearance="form-trigger"
              size="s"
              tuiHintAppearance="floating"
              tuiHintDirection="end"
              tuiIconButton
              type="button"
              [iconStart]="triggerIcon"
              [tuiHint]="triggerLabel"
              (click)="triggerModule(module)">
              {{ triggerLabel }}
            </button>
          } @else {
            <button
              appearance="form-trigger"
              size="s"
              tuiButton
              type="button"
              [iconStart]="triggerIcon"
              (click)="triggerModule(module)">
              {{ triggerLabel }}
            </button>
          }
        </div>
      </div>
    } @else {
      @if (module.isTriggered) {
        <button
          appearance="outline"
          iconStart="@tui.rotate-ccw"
          size="s"
          tuiHintAppearance="floating"
          tuiIconButton
          type="button"
          [attr.data-testid]="'grid-trigger-question-reset-' + module.moduleId"
          [tuiHint]="t('Réinitialiser')"
          (click)="resetModule(module)">
          {{ t('Réinitialiser') }}
        </button>
      } @else {
        <button
          appearance="form-trigger"
          size="s"
          tuiIconButton
          type="button"
          [attr.data-testid]="'grid-trigger-question-' + module.moduleId"
          [iconStart]="triggerIcon"
          [tuiHint]="description ? questionHint : triggerLabel"
          (click)="triggerModule(module)">
          {{ triggerLabel }}
        </button>
        <ng-template #questionHint>
          <div class="flex flex-col gap-1">
            <p class="font-medium">{{ triggerLabel }}</p>
            <p>{{ description }}</p>
          </div>
        </ng-template>
      }
    }
  }
</ng-container>
